import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import * as Yup from "yup";
import { getOtp, getOtpContractFarming } from "../services/Un_auth_services";
import HomeHeader from "../../home/homeHeader";
import "./register.css";
import { useSelector } from "react-redux";
import { toast,ToastContainer } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
import { verifyCaptcha } from "../services/privateapicalling";
// import Toast from "react-native-toast-message";
type PasswordField = "password" | "confirmPassword";

const Register3 = () => {
  const routes = all_routes;
  const navigation = useNavigate();
  const [searchParams] = useSearchParams();
  const language = useSelector((state: any) => state.auth.language);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [isOtpRequested, setIsOtpRequested] = useState(false);
  const [hasErrorToastShown, setHasErrorToastShown] = useState(false);
   const [isRecaptchaVerified, setIsRecaptchaVerified] = useState(false);
     const [errorMessage, setErrorMessage] = useState("");
   
  
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    const recaptchaRef = useRef(null);
  
  const selectedRole = decodeURIComponent(
    searchParams.get("role") || "Not Selected"
  )
    .replace(/_/g, " ")
    .replace(/\s*Registration$/, "");

    const role =searchParams.get("role")
    

  const selectedURL = decodeURIComponent(
    searchParams.get("role") || "Not Selected"
  );
  const updatedURL = selectedURL.replace("Registration", "Login");

    const formLanguage = useSelector((state: any) => state.auth.formLanguage)

     const handleRecaptchaChange = async(token) => {
        // setIsRecaptchaVerified(true); // Just mark it as verified
          const captchaRes = await verifyCaptcha(token);
          if (captchaRes.success) {
            setIsRecaptchaVerified(true);
          }
           else {
            setErrorMessage("CAPTCHA failed. Try again.");
          }
    
      };
  

  const [formValues, setFormValues] = useState({
    User_type: selectedRole,
    title: "",
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    userType: "",
    email: "",
    mobileNo: "",
    password: "",
    confirmPassword: "",
    organisation:"",
  });



  const allowedRoles = [
    "Trader_Registration",
    "Panel_Engineer_Registration",
    "Trader_Login",
    "Panel_Engineer_Login",
    "District_Registrar_Login",
    "APMC_Login",
    "Head_officer_Login",
    "GCA_Login",
     "GCA_Registration",
 "Sponsor_Login",
     "Sponsor_Registration"

  ];
  
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  useEffect(() => {
    if (hasErrorToastShown) {
      const timer = setTimeout(() => {
        setHasErrorToastShown(false);
      }, 3000); // 3 seconds

      return () => clearTimeout(timer); // Cleanup function to prevent memory leaks
    }
  }, [hasErrorToastShown]);

  
  useEffect(() => {
    if (!role||!allowedRoles.includes(role ?? "")) {
      navigation(routes.error404); 
    }
  }, [role]);

  const handleGetOtp = async (e: { preventDefault: () => void }) => {
    e.preventDefault();

    //  if (!isRecaptchaVerified) {
    //   setErrorMessage("Please complete the reCAPTCHA verification.");

    //   return;
    // }
 
    if (isOtpRequested) return; // Prevent multiple clicks
    setIsOtpRequested(true); // Disable button after first click
    try {
      const isValid = await validationSchema.validate(formValues, { abortEarly: false });

      if (isValid == null) {
          if (!hasErrorToastShown) {
              toast.error("Validation Error: Please check your inputs.", { position: "top-center" });
              setHasErrorToastShown(true); // Mark error toast as shown
          }
          setIsOtpRequested(false);
          return;
      }
   
      if (!isValid) return; 
      
      setErrors({});
 
      const response =selectedRole==="Sponsor"?await getOtpContractFarming(formValues): await getOtp(formValues);
      if (response.Status==true) {
        //.log("MESSAGE......", response.Message);
        toast.success("OTP Sent Successfully!", { position: "top-center" });
        //.log("referenceID",response.RefId)
        const tr=response.RefId;
        
        navigation(routes.twoStepVerification3, {
          state: { formValues, navigatePath: "login", selectedURL,tr },
        });
        // if (response.Message === "User Already Registered") {
        //   navigation(routes.register3);
        // } else {
        //   navigation(routes.twoStepVerification3, {
        //     state: { formValues, navigatePath: "login", selectedURL,tr },
        //   });
        // }
      } else {
        toast.error(response.Message, { position: "top-center" });
        setIsOtpRequested(false);
       // Re-enable if request fails
      }
 
    
      setFormValues({
        User_type: selectedRole,
        title: "",
        firstName: "",
        middleName: "",
        lastName: "",
        gender: "",
        userType: "",
        email: "",
        mobileNo: "",
        password: "",
        confirmPassword: "",
        organisation:"",
      });
    } catch (error) {
      //.log("error", error);
      setIsOtpRequested(false); // Re-enable button on error
 
      if (error instanceof Yup.ValidationError) {
        const newErrors: { [key: string]: string } = {};
        error.inner.forEach((err) => {
            if (err.path) newErrors[err.path] = err.message;
        });
      
        setErrors(newErrors);

        if (!hasErrorToastShown) {
            toast.error("Validation Error: Please check your inputs.", { position: "top-center" });
            setHasErrorToastShown(true);
        }
      }
      
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
  
    setFormValues((prevValues) => {
      let updatedValues = { ...prevValues, [name]: value };
  
     
      if (name === "title") {
        if (value === "Mr") {
          updatedValues = { ...updatedValues, gender: "Male" };
        } else if (value === "Miss" || value === "Mrs") {
          updatedValues = { ...updatedValues, gender: "Female" };
        } else {
          updatedValues = { ...updatedValues, gender: "" }; 
        }
      }
  
      return updatedValues;
    });
  
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),

    organisation: Yup.string().when("SelectedRole", (SelectedRole, schema) => {
      return selectedRole === "Sponsor"
        ? schema.required("Organisation is required")
        : schema.notRequired();
    }),
    
    firstName: Yup.string()
      .matches(
        /^[A-Za-z]+$/,
        "First name cannot contain numbers or special characters"
      )
      .max(20, "First name cannot be more than 20 characters")
      .required("First name is required"),
    gender: Yup.string().required("Gender is required"),
    userType: Yup.string().when("User_type", {
      is: (value: unknown) => value === "Trader",
      then: (schema) => schema.required("Applicant Type is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    mobileNo: Yup.string()
      .matches(
        /^[6789]\d{9}$/,
        "Mobile number must start with 6,7, 8, or 9 and be exactly 10 digits"
      )
      .required("Mobile number is required"),
    middleName: Yup.string()
      .nullable()
      .notRequired()
      .test(
        "middleName",
        "Middle name cannot contain numbers or special characters",
        (value) => !value || /^[A-Za-z]+$/.test(value)
      )
      .test(
        "middleName-length",
        "Middle name cannot be more than 20 characters",
        (value) => !value || value.length <= 20
      ),

    lastName: Yup.string()
     
    .matches(
      /^[A-Za-z]+$/,
      "Last name cannot contain numbers or special characters"
    )
    .max(20, "Last name cannot be more than 20 characters")
    .required("Last name is required"),

    email: Yup.string()
      .email("Invalid email format")
      .min(10, "Email must be at least 10 characters long")
      .max(60, "Email cannot exceed 60 characters")
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/[0-9]/, "Password must contain at least one number")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Password must contain at least one special character"
      )
      .required("Password is required")
      .max(20, "Password cannont exceed 20 characters"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Passwords must match")
      .required("Confirm Password is required"),
  });

  return (
    <>
      <div>
        <HomeHeader />
      </div>
      <div className="container-fuild">
     

        <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
          <div className="row">
            <div className="col-lg-7  d-none d-lg-block vh-100 p-0 position-relative">
              <div className="w-100 h-100 position-absolute top-0 start-0">
                <ImageWithBasePath
                  src="assets/img/Registration.jpeg"
                  alt="Img"
                  className="w-100 h-100 "
                />
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 bg-white">
              <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
                {/* <div className="col-md-4 mx-auto vh-100 " > */}
                <form className="vh-100">
                  <div className="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
                    <div className=" mx-auto mb-5 text-center">
                      {/* <ImageWithBasePath
                    src="assets/img/gil_logo.jpg"
                    className="img-fluid"
                    alt="Logo"
                  /> */}
                    </div>
                    <div className="text-center mb-3 ">
                      <h2 className="mb-2">
                        {" "}
                        {language.registration_type} {selectedRole}
                      </h2>
                      {/* <p className="mb-0">{language.reg_heading}</p> */}
                    </div>
                    <div className=" w-full p-4 mb-3 vh-90 overflow-auto scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-200">
                   <div className="mb-3">
                        <label className="form-label">
                          {formLanguage.title} ({language.title}){" "}
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          name="title"
                          value={formValues.title}
                          onChange={handleChange}
                        >
                          <option value="">{language.sel_tit}</option>
                          <option value="Mr">{language.mr}</option>
                          <option value="Mrs">{language.mrs}</option>
                          <option value="Miss">{language.miss}</option>
                          
                        </select>
                        {errors.title && (
                          <div className="text-danger">{errors.title}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          {" "}
                          {formLanguage.first_name} ({language.first_name})
                          <span className="text-danger"> *</span>
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            defaultValue=""
                            name="firstName"
                            className="form-control border-end-0"
                            value={formValues.firstName}
                            onKeyDown={handleKeyDown}
                            onChange={(e) => {
                              const regex = /^[A-Za-z\s]*$/;
                              if (regex.test(e.target.value)) {
                                handleChange(e);
                              }
                            }}
                            maxLength={20}
                            placeholder="Enter First Name"
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-user" />
                          </span>
                        </div>
                        {errors.firstName && (
                          <div className="text-danger">{errors.firstName}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          {" "}
                          {formLanguage.middle_name} ({language.middle_name})
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            name="middleName"
                            defaultValue=""
                            className="form-control border-end-0"
                            onKeyDown={handleKeyDown}
                            value={formValues.middleName}
                            onChange={(e) => {
                              const regex = /^[A-Za-z\s]*$/;
                              if (regex.test(e.target.value)) {
                                handleChange(e);
                              }
                            }}
                            maxLength={20}
                            placeholder="Enter Middle Name"
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-user" />
                          </span>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          {" "}
                          {formLanguage.last_name} ({language.last_name})
                          <span className="text-danger"> *</span>
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            defaultValue=""
                            name="lastName"
                            className="form-control border-end-0"
                            value={formValues.lastName}
                            onKeyDown={handleKeyDown}
                           
                            onChange={(e) => {
                              const regex = /^[A-Za-z\s]*$/;
                              if (regex.test(e.target.value)) {
                                handleChange(e);
                              }
                            }}
                            maxLength={20}
                            placeholder="Enter Last Name"
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-user" />
                          </span>
                        </div>
                        {errors.lastName && (
                          <div className="text-danger">{errors.lastName}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                        {formLanguage.gender} ({language.gender}){" "}
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          name="gender"
                          value={formValues.gender}
                          onChange={handleChange}
                        >
                          <option value="">{language.sel_gen}</option>
                          <option value="Male">{language.male}</option>
                          <option value="Female">{language.female}</option>
                          <option value="Other">{language.other}</option>
                        </select>
                        {errors.gender && (
                          <div className="text-danger">{errors.gender}</div>
                        )}
                      </div>

                      {selectedRole === "Trader" && (
                        <div className="mb-3">
                          <label className="form-label">
                            {formLanguage.applicant_type} ({language.applicant_type}){" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            name="userType"
                            value={formValues.userType}
                            onChange={handleChange}
                          >
                            <option value="">{language.sel_app_type}</option>
                            <option value="Individual">{language.individual}</option>
                            <option value="Company">{language.company}</option>
                            <option value="Partnership">{language.fir}</option>
                            <option value="Cooperative Society">
                              {language.co_soc}
                            </option>
                            <option value="Farmer Producer Organization (FPO)">
                              {language.fpoo}
                            </option>
                            <option value="Government Entity">
                              {language.ge}
                            </option>
                            <option value="Non-Governmental Organization (NGO)">
                              {language.ngo}
                            </option>
                            <option value="Partnership Firm">
                              {language.pa_fir}
                            </option>
                            <option value="Limited Liability Partnership (LLP)">
                              {language.llp}
                            </option>
                            <option value="Trust">{language.trust}</option>
                            <option value="Joint Venture">{language.jv}</option>
                          </select>
                          {errors.userType && (
                            <div className="text-danger">{errors.userType}</div>
                          )}
                        </div>
                      )}
                         {selectedRole==="Sponsor" &&   <div className="mb-3">
                        <label className="form-label">
                          {formLanguage.organisation} ({language.organisation}){" "}
                          <span className="text-danger">*</span>
                        </label>
                     <div className="input-group">
                          <input
                            type="text"
                            defaultValue=""
                            name="organisation"
                            className="form-control border-end-0"
                            value={formValues.organisation}
                            // onKeyDown={handleKeyDown}
                            onChange={(e) => {
                            
                                handleChange(e);
                             
                            }}
                            // maxLength={20}
                            placeholder="Enter Organisation Name"
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-briefcase" />
                          </span>
                        </div>
                        {errors.organisation && (
                          <div className="text-danger">{errors.organisation}</div>
                        )}
                      
                      </div>}

                      <div className="mb-3">
                        <label className="form-label">
                        {formLanguage.email} ({language.email}){" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            defaultValue=""
                            className="form-control border-end-0"
                            name="email"
                            maxLength={60}
                            value={formValues.email}
                            onKeyDown={handleKeyDown}
                            autoComplete="new-email"
                            onChange={handleChange}
                            placeholder="Enter Email Id"
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-mail" />
                          </span>
                        </div>
                        {errors.email && (
                          <div className="text-danger">{errors.email}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                        {formLanguage.mobile} ({language.mobile}){" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="tel"
                          className="form-control"
                          name="mobileNo"
                          value={formValues.mobileNo}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || /^[6789]\d{0,9}$/.test(value)) {
                              handleChange(e);
                            }
                          }}
                          maxLength={10}
                          placeholder="Enter mobile number"
                        />
                          {errors.mobileNo && (
                          <div className="text-danger">{errors.mobileNo}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                        {formLanguage.password} ({language.password}){" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="pass-group">
                          <input
                            type={
                              passwordVisibility.password ? "text" : "password"
                            }
                            className="pass-input form-control"
                            value={formValues.password}
                            onChange={handleChange}
                            name="password"
                            placeholder="Enter Password"
                            autoComplete="new-password"
                            maxLength={20}
                          />
                          <span
                            className={`ti toggle-passwords ${
                              passwordVisibility.password
                                ? "ti-eye"
                                : "ti-eye-off"
                            }`}
                            onClick={() => togglePasswordVisibility("password")}
                          ></span>
                        </div>
                        {errors.password && (
                          <div className="text-danger">{errors.password}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                        {formLanguage.confirm_password} ({language.confirm_password})
                          <span className="text-danger">*</span>
                        </label>
                        <div className="pass-group">
                          <input
                            type={
                              passwordVisibility.confirmPassword
                                ? "text"
                                : "password"
                            }
                            className="pass-input form-control"
                            value={formValues.confirmPassword}
                            onChange={handleChange}
                            name="confirmPassword"
                            maxLength={20}
                            placeholder="Enter Confirm Password"
                          />
                          <span
                            className={`ti toggle-passwords ${
                              passwordVisibility.confirmPassword
                                ? "ti-eye"
                                : "ti-eye-off"
                            }`}
                            onClick={() =>
                              togglePasswordVisibility("confirmPassword")
                            }
                          ></span>
                          {errors.confirmPassword && (
                            <div className="text-danger">
                              {errors.confirmPassword}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center">
                          <div className="form-check form-check-md mb-0"></div>
                        </div>
                      </div>

                      <div className="login-or">
                        {/* <span className="span-or">Or</span> */}
                      </div>
                      <div className="mt-2"></div>
                    </div>
                      {errorMessage && (
                          <p className="text-danger">{errorMessage}</p>
                        )}
                     {/* <div className="d-flex justify-content-center text-center my-3">
                      
                                              <ReCAPTCHA
                                                sitekey= {siteKey}
                                                 ref={recaptchaRef} 
                                                onChange={handleRecaptchaChange}
                                                size="normal"
                                              />
                                            </div> */}

                    <div className="mb-3">
                    <button
                        type="submit"
                        onClick={handleGetOtp}
                        className="btn btn-success w-100"
                        disabled={isOtpRequested}
                      >
                        {isOtpRequested ? "OTP Sent" : language.get_otp}
                      </button>
                    </div>
                    <ToastContainer position="top-left" autoClose={3000} />
                    <div className="text-center">
                      <h6 className="fw-normal text-dark mb-0">
                        {language.dontaccount}
                        <Link
                          to={`${all_routes.login2}?role=${encodeURIComponent(
                            updatedURL
                          )}`}
                          className="text-success"
                        >
                         &nbsp; {language.sign_in}
                        </Link>
                      </h6>
                    </div>
                    <div className="mt-5 pb-4 text-center"></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
       
      </div>
    </>
  );
};

export default Register3;
